export var withErrorHandler = function (_a) {
    var httpClient = _a.httpClient, errorHandler = _a.errorHandler;
    if (!httpClient || httpClient._requestWasOverridden) {
        return;
    }
    var originalRequest = httpClient.request.bind(httpClient);
    httpClient.request = function (requestParams) {
        return errorHandler
            .withErrorHandler(function () { return originalRequest(requestParams); }, {
            errorCodesMap: {},
        })
            .catch(function (error) {
            throw errorHandler.getResolvedError(error);
        });
    };
    httpClient._requestWasOverridden = true;
};
//# sourceMappingURL=withErrorHandler.js.map